import axios from "utils/axiosConfig";
import uri from "../config";
import { getConfig } from "../auth/authService";

const createOrder = async (orderData, idempotencyKey = null) => {
  const config = getConfig();
  if (idempotencyKey) {
    config.headers["X-Idempotency-Key"] = idempotencyKey;
  }
  const response = await axios.post(`${uri}/api/orders`, orderData, config);
  return response.data;
};

const getOrders = async (email) => {
  const response = await axios.get(`${uri}/api/orders/${email}`, getConfig());
  return response.data;
};

const getAllOrders = async () => {
  const response = await axios.get(`${uri}/api/orders`, getConfig());
  return response.data;
};

const updateOrderStatus = async (id, status) => {
  const response = await axios.put(
    `${uri}/api/orders/${id}`,
    { status },
    getConfig()
  );
  return response.data;
};

const deleteOrder = async (id) => {
  const response = await axios.delete(`${uri}/api/orders/${id}`, getConfig());
  return response.data;
};

const orderService = {
  createOrder,
  getOrders,
  getAllOrders,
  updateOrderStatus,
  deleteOrder,
};

export default orderService;
